import './home-works.scss'
import {getPropsFromState} from "../../../redux/mapStateToProps";
import {AddSubscribers} from "../../../redux/actions";
import {connect} from "react-redux";
import {WorkBlock1Icon, WorkBlock2Icon, WorkBlock3Icon} from "../../../assets/images";


function HomeWorks(props) {
    const {staticTexts} = props;
    const WorksBlock = [
        {
            title:staticTexts?.homepage_works_block1_title,
            description:staticTexts?.homepage_works_block1_description,
            icon:<WorkBlock1Icon/>
        },
        {
            title:staticTexts?.homepage_works_block2_title,
            description:staticTexts?.homepage_works_block2_description,
            icon:<WorkBlock2Icon/>
        },
        {
            title:staticTexts?.homepage_works_block3_title,
            description:staticTexts?.homepage_works_block3_description,
            icon:<WorkBlock3Icon/>
        },
    ]
    return <div className={'work_wrapper'}>
        <div className={'work_title'}>
            {staticTexts?.homepage_works_title || 'Строим комфортную жизнь'}
        </div>
        <div className={'work_content'}>
            {
                WorksBlock?.map((item, index) => {
                    return <div className={'work_item'} key={index}>
                        <div>{item?.icon}</div>
                        {
                            item?.title ?   <div className={'work_item_title'}>{item?.title}</div> : ''
                        }
                        {
                            item?.description ? <div className={'work_item_description'}>{item?.description}</div> : ''
                        }
                    </div>
                })
            }
        </div>
    </div>
}
const mapStateToProps = (state) => getPropsFromState(state, [
    'staticTexts',
    'requestLoading',
    'works'
]);

const mapDispatchToProps = {
    AddSubscribers
};

export default connect(mapStateToProps, mapDispatchToProps)(HomeWorks);